<template>
  <div id="app">
    <router-view />
    <susp-consult />
  </div>
</template>

<script>
import SuspConsult from "@/components/SuspConsult";
export default {
  name: "App",
  components: {
    SuspConsult,
  },
};
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
}
#app {
  min-height: 100vh;
  position: relative;
}
.el-dialog__wrapper {
  z-index: 9999 !important;
}
.el-message {
  z-index: 9999 !important;
}
</style>
